<template>
  <div class="whole" aspectratio>
    <img src="@/assets/images/tools_bg.png" />
    <div class="module_entry" aspectratio-center flexContainer>
      <div class="entry" aspectratio @click="go_tools">
        <figure aspectratio-center>
          <img src="@/assets/images/app_test.png" />
          <figcaption>内测app发布</figcaption>
          <figcaption>点击进入</figcaption>
        </figure>
      </div>
      <div class="entry popular" aspectratio>
        <figure aspectratio-center>
          <img src="@/assets/images/tool_short.png" />
          <figcaption>网址缩短</figcaption>
          <figcaption>新功能开发中</figcaption>
        </figure>
      </div>
      <div class="entry popular" aspectratio>
        <figure aspectratio-center>
          <img src="@/assets/images/tool_qrcode.png" />
          <figcaption>二维码工具</figcaption>
          <figcaption>新功能开发中</figcaption>
        </figure>
      </div>
      <div class="entry popular" aspectratio>
        <figure aspectratio-center>
          <img src="@/assets/images/tool_ip.png" />
          <figcaption>IP查询</figcaption>
          <figcaption>新功能开发中</figcaption>
        </figure>
      </div>
      <div class="entry popular" aspectratio>
        <figure aspectratio-center>
          <img src="@/assets/images/tool_zip.png" />
          <figcaption>图片压缩</figcaption>
          <figcaption>新功能开发中</figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: mapState(["isTabShow"]),
  methods: {
    go_tools() {
      this.$store.state.isTabShow = true;
      this.$router.push({
        path: "/tools_f",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.whole {
  img {
    width: 100%;
    height: 100%;
  }
  .module_entry {
    width: 868px;
    justify-content: space-between;
    flex-wrap: wrap;
    .popular {
      opacity: 0.6;
    }
    .entry {
      box-shadow: 0px 10px 13px 0px rgba(0, 0, 0, 0.04);
      width: 202px;
      height: 202px;
      margin-top: 20px;
      border-radius: 14px;
      background-color: $menu-color;
      figure {
        margin: 0;
        text-align: center;
        img {
          width: 62px;
          height: 62px;
        }
        figcaption {
          margin: 8px 0px 0px 0px;
        }
        &:nth-child(1) {
          @include s-c-w(14, $detail_t, 500);
        }
        & > figcaption:last-child {
          @include s-c-w(12, $text-other, 500);
          margin: 5px 0px 0px 0px;
        }
      }
    }
  }
}
</style>